import {HardHat, User, MapTrifold, CodesandboxLogo, ChartLineUp} from "@phosphor-icons/react";

const dashboardMenu = [
  {
    "label": "Projects",
    "link": "/pages/projects",
    "icon": <HardHat size={16} />
  },
  {
    "label": "Landowners",
    "link": "/pages/owners",
    "icon": <User size={16} />
  },
  {
    "label": "Properties",
    "link": "/pages/properties",
    "icon": <MapTrifold size={16} />
  },
  {
    "label": "Sandbox",
    "link": "/pages/sandbox",
    "icon": <CodesandboxLogo size={16} />
  },
  {
    "label": "Metrics",
    "link": "/pages/metrics",
    "icon": <ChartLineUp size={16} />
  }
];



export { dashboardMenu };